var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        width: "350",
        trigger: "hover",
        "popper-class": "goods-popover",
        "append-to-body": true,
      },
      on: { show: _vm.getCustomerHistorySkuList },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "goods-wrap",
          style: { minHeight: _vm.loading ? "200px" : "auto" },
        },
        [
          _c(
            "div",
            { staticClass: "goods-wrap-list" },
            [
              _vm._l(_vm.list, function (item, index) {
                return [
                  _c(
                    "div",
                    { key: index, staticClass: "goods-wrap-item" },
                    [
                      _c(
                        "el-badge",
                        { attrs: { value: item.qty } },
                        [
                          _c("ZImg", {
                            staticClass: "goods-image",
                            attrs: { src: item.skuIcon },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "goods-item-info" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$dataCheck(item.spuName)) + " "
                          ),
                        ]),
                        _c("p", { staticStyle: { "margin-top": "8px" } }, [
                          _vm._v(_vm._s(_vm.$dataCheck(item.skuAttr))),
                        ]),
                        _c("p", { staticStyle: { "margin-top": "8px" } }, [
                          _vm._v(
                            "物流状态：" +
                              _vm._s(_vm.$dataCheck(item.orderSubStatus))
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "el-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.row.qty,
              expression: "row.qty",
            },
          ],
          staticStyle: { padding: "5px" },
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [_vm._v("...")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }